// extracted by mini-css-extract-plugin
export var videoContainer = "video-module--video-container--9d50b";